// Action → Markdown composition, shared by the pane's copy button and the
// .md export (refactor phase 1).
export const slugify = (s) => (s || 'action').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'action';

export function composeActionMarkdown(action, bodyMd) {
  const parts = [`# ${action.text || 'Untitled action'}`];
  if (action.nextStep) parts.push(`> **Next step:** ${action.nextStep}`);
  if (bodyMd && bodyMd.trim()) parts.push(bodyMd.trim());
  const tasks = action.checklist || [];
  if (tasks.length > 0) {
    parts.push('## Tasks\n' + tasks.map(t => `- [${t.completed ? 'x' : ' '}] ${t.text}`).join('\n'));
  }
  return parts.join('\n\n') + '\n';
}

